import * as Yup from "yup";

export const dataModel = {
  name: "",
  frontCode: "",
  personType: [],
  active: false,
  description: "",
  fields: "",
};

export const validationDataModel = (edit) => {
  if (edit) {
    return Yup.object().shape({
      name: Yup.string().required("forms.validations.required"),
      frontCode: Yup.string().required("forms.validations.required"),
      personType: Yup.array().required("forms.validations.required"),
      active: Yup.boolean().required("forms.validations.required"),
      description: Yup.string().optional(""),
      fields: Yup.array().optional(""),
    });
  }

  return Yup.object().shape({
    name: Yup.string().required("forms.validations.required"),
    frontCode: Yup.string().required("forms.validations.required"),
    personType: Yup.array().required("forms.validations.required"),
    active: Yup.boolean().required("forms.validations.required"),
    description: Yup.string().optional(""),
    fields: Yup.array().optional(""),
  });
};

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
